import React, { Component, PropTypes } from 'react'
import { Colors, Metrics, Fonts } from '../../Themes'
import styled from 'styled-components'
import CloseIcon from '../../svg-icons/CloseIcon'
import ThemeContainer from '../../components/ThemeContainer'

const Container = styled.div`
  transition: ease-out all 0.5s;
  background-color: white;
  position: absolute;
  height: 40px;
  width: calc(100vw - 30px);
  border: ${Metrics.borders.default};
  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08) !important;
  border-radius: 4px;
  z-index: 2;
  left: 15px;
  top: 80px;

  &.open {
    transition: ease-in all 0.3s;
    box-shadow: none;
    height: 100vh;
    width: 100vw;
    overflow: none;
    left: 0;
    top: 0;
  }
`

const Close = styled.div`
  height: 40px;
  position: relative;
  svg {
    position: absolute;
    right: 5%;
  }
`

const Apply = styled.div`
  text-align: center;
  padding: ${Metrics.margins.small};
  margin-top: ${Metrics.margins.base};
  position: absolute;
  bottom: ${Metrics.margins.base};
  width: 100%;

  button {
    background: ${Colors.primary};
    color: ${Colors.white};
    float: inherit;
    width: 100%;
  }
`

const MenuWrapper = styled.div`
  display: none;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    height: 60px;
    display: block;
  }
`

const MenuButton = styled.div`
  margin: 12px ${Metrics.margins.small};
  span {
    float: left;
    ${Fonts.style.Text};
    color: ${Colors.darkgrey};
    font-size: ${Fonts.size.medium};
  }
  svg {
    float: right;
    margin-top: -3px;
    fill: ${Colors.primary};
  }
  transition: ease-in all 0.3s;
  opacity: 1;

  &.open {
    transition: ease-in all 0.1s;
    opacity: 0;
  }
`

const MenuBody = styled.div`
  pointer-events: none;
  opacity: 0;
  height: calc(100% - ${Metrics.margins.base});
  overflow: none;
  &.open {
    pointer-events: all;
    opacity: 1;
    transition: ease-in all 0.2s;
    transition-delay: 0.3s;
  }
`

const Children = styled(ThemeContainer)`
  max-height: calc(100% - 100px);
  overflow-y: scroll;
`

class MobileMenu extends Component {
  render () {
    const { children, open, toggleMenu, apply, label, icon } = this.props
    return (
      <MenuWrapper className={open && 'open'}>
        <Container className={open && 'open'}>
          <MenuButton onClick={toggleMenu} className={open && 'open'}>
            <span>{label}</span>
            {icon}
          </MenuButton>
          <MenuBody className={open && 'open'}>
            <Close>
              <CloseIcon onClick={toggleMenu} />
            </Close>
            <Children>{children}</Children>
            <Apply>{apply}</Apply>
          </MenuBody>
        </Container>
      </MenuWrapper>
    )
  }
}

MobileMenu.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  apply: PropTypes.node,
  toggleMenu: PropTypes.func,
  open: PropTypes.bool,
  icon: PropTypes.node
}

export default MobileMenu



// WEBPACK FOOTER //
// ./src/components/MobileMenu/index.js